export enum DocumentVisibilityStateEnum {
  HIDDEN = 'hidden',
  VISIBLE = 'Visible',
}
